// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"CustomersDataReport_contentComponent__dirVV","tableContainer":"CustomersDataReport_tableContainer__28lOg","totalRow":"CustomersDataReport_totalRow__3PI7-"};